'use client'

import * as React from 'react'

export interface CreateClassProjectDialogContextModel {
  isOpen: boolean
  openDialog: () => void
  closeDialog: () => void
}

const CreateClassProjectDialogContext = React.createContext<CreateClassProjectDialogContextModel>(
  null!,
)

export const CreateClassProjectDialogProvider = ({ children }: React.PropsWithChildren) => {
  const [isOpen, setIsOpen] = React.useState<boolean>(false)

  const openDialog = () => {
    setIsOpen(true)
  }

  const closeDialog = () => {
    setIsOpen(false)
  }

  return (
    <CreateClassProjectDialogContext.Provider value={{ isOpen, closeDialog, openDialog }}>
      {children}
    </CreateClassProjectDialogContext.Provider>
  )
}

export const useCreateClassProjectDialog = () => {
  const context = React.useContext(CreateClassProjectDialogContext)

  if (context === undefined) {
    throw new Error(
      'useCreateClassProjectDialog must be used within a CreateClassProjectDialogProvider',
    )
  }

  return context
}
